'use client';

import Link from '@eliadmin/core/src/components/link';

import { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Logo } from '@eliadmin/core/src/components/ui/logo';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function CartHeader({ generalLayout }: { generalLayout: GeneralLayout['data'] }) {
  const { t } = useTranslations();
  return (
    <header className={cn('custom-section', 'border-b py-[10px] sm:py-3')}>
      <div className={cn('custom-container', 'hidden items-center justify-between sm:flex')}>
        <Heading title={t('text163')} tag="h3" className={{ title: 'tracking-tighter' }} />
        <Logo className={{ image: 'h-[60px]' }} generalLayout={generalLayout} />
        <Paragraph color="foreground" size="base" className="text-right">
          Pomoc pri objednávke:{' '}
          <Link
            prefetch={false}
            href={`tel:${generalLayout?.contact?.phone}`}
            target="_blank"
            className="font-bold"
          >
            {generalLayout?.contact?.phone}
          </Link>
        </Paragraph>
      </div>
      <div className="flex w-full items-center justify-between sm:hidden">
        <div className="flex w-full max-w-[202px] flex-col items-start justify-start gap-1">
          <Heading title={t('text163')} tag="h3" className={{ title: 'tracking-tighter' }} />
          <Paragraph color="foreground" size="sm" className="text-left">
            Pomoc pri objednávke: <br />
            <Link
              prefetch={false}
              href={`tel:${generalLayout?.contact?.phone}`}
              target="_blank"
              className="font-bold"
            >
              {generalLayout?.contact?.phone}
            </Link>
          </Paragraph>
        </div>
        <Logo className={{ image: 'h-10' }} generalLayout={generalLayout} />
      </div>
    </header>
  );
}
